export const creditCardKeys = {
  accountNumberToken: 'accountNumberToken',
  accountNumberMasked: 'accountNumberMasked',
  cardExpiration: 'cardExpiration',
  cardExpirationMonth: 'cardExpirationMonth',
  cardExpirationYear: 'cardExpirationYear',
  cardCvv: 'cardCvv',
};

export const achKeys = {
  accountType: 'accountType',
  achAccountHolderType: 'achAccountHolderType',
  achRoutingNumber: 'achRoutingNumber',
  achAccountNumber: 'achAccountNumber',
  achConfirmAccountNumber: 'achConfirmAccountNumber',
};

export const addressKeys = {
  streetAddress: 'streetAddress',
  streetAddress2: 'streetAddress2',
  city: 'city',
  state: 'state',
  zipCode: 'zipCode',
};

export const fieldKeys = {
  accountHolderName: 'accountHolderName',
  ...creditCardKeys,
  ...achKeys,
  ...addressKeys,
};
